<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                fileForm: () => import('../forms/FileForm'),
                temperatureCheckForm: () => import('../forms/TemperatureCheckForm'),
                fields: [
                    { type: 'autocomplete', text: 'Temperature Check', value: 'temperatureCheckId', rules: [v => !!v || 'Temperature Check is required'], isRequired: true, form: () => import('./TemperatureCheckForm'), apiMethod: 'TemperatureChecks', claim: 'TemperatureChecks' },
                    { type: 'file', text: 'File', value: 'fileId', rules: [v => !!v || 'File is required'], isRequired: true, form: () => import('./FileForm'), apiMethod: 'Files' },
                ],
                apiMethod: 'TemperatureCheckFiles',
                formTitle: 'Temperature Check File',
            }
        },
    };
</script>
